/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailibilityRequestModel } from '../../models/availibility-request-model';
import { UrnAvailabilityDayModelAvailibilityModel } from '../../models/urn-availability-day-model-availibility-model';

export interface DiaryAvailibilitySecurePost$Params {
      body?: AvailibilityRequestModel
}

export function diaryAvailibilitySecurePost(http: HttpClient, rootUrl: string, params?: DiaryAvailibilitySecurePost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<UrnAvailabilityDayModelAvailibilityModel>>> {
  const rb = new RequestBuilder(rootUrl, diaryAvailibilitySecurePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<UrnAvailabilityDayModelAvailibilityModel>>;
    })
  );
}

diaryAvailibilitySecurePost.PATH = '/Diary/AvailibilitySecure';
